import { render, staticRenderFns } from "./UserVerifiedRoleChip.vue?vue&type=template&id=f99cfbb6&scoped=true&"
import script from "./UserVerifiedRoleChip.vue?vue&type=script&lang=ts&"
export * from "./UserVerifiedRoleChip.vue?vue&type=script&lang=ts&"
import style0 from "./UserVerifiedRoleChip.vue?vue&type=style&index=0&id=f99cfbb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99cfbb6",
  null
  
)

export default component.exports